﻿import "./pixi-extensions";

//----------------------------------------------------------------------------------------------------------------------

export class UIBase extends PIXI.Sprite {
    constructor(...args) {
        super(...args);
        this.Active = true;
        this.HideWithBackButton = false;
        this.Awake();
    }
}
